<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready">
            <div class="card mb-5">
                <div class="card-title" v-once>
                    <span>Настройка комиссий</span>
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div v-for="distribution in distributions" :key="distribution.id">
                        <div class="flex -mx-2">
                            <select-field
                                class="w-1/2 px-2"
                                title="Тип комиссии"
                                label="label"
                                valueName="name"
                                :clearable="false"
                                v-model="distribution.type"
                                :options="distributionTypes"
                            />

                            <select-field
                                class="w-1/2 px-2"
                                title="Тип продукта"
                                label="label"
                                valueName="name"
                                :clearable="false"
                                v-model="distribution.distributable_type"
                                :options="distributables"
                            />
                        </div>

                        <div class="flex -mx-2">
                            <select-field
                                class="w-1/2 px-2"
                                :title="distribution.distributable_type == 'product' ? 'Товар' : 'Категория'"
                                label="name"
                                valueName="id"
                                :clearable="false"
                                v-model="distribution.distributable_id"
                                :options="distribution.distributable_type == 'product' ? selects.products : selects.productCategories"
                            />

                            <text-field
                                class="w-1/2 px-2"
                                :title="'Комиссия (Продажа), ' + (distribution.type == 'rate' ? '%' : '₽')"
                                v-model="distribution.amount"
                                required
                            />

                            <text-field
                                class="w-1/2 px-2"
                                :title="'Комиссия (Аренда), ' + (distribution.type == 'rate' ? '%' : '₽')"
                                v-model="distribution.amount_rent"
                                required
                            />
                        </div>

                        <button
                            @click.prevent="removeDistribution(distribution)"
                            class="btn btn-danger"
                        >Удалить</button>

                        <hr class="mb-3 mt-3" />
                    </div>

                    <button class="btn btn-primary">Сохранить</button>
                    <button @click.prevent="addDistribution" class="btn btn-info">Добавить</button>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        modelType: String,
        modelId: [String, Number]
    },

    data() {
        return {
            distributions: [],

            resource: {
                endpoint: `admin/billing/distributions/${this.modelType}/${this.modelId}`,
                ready: false
            },

            distributionTypes: [
                {
                    name: "rate",
                    label: "Доля, %"
                },
                {
                    name: "amount",
                    label: "Сумма, ₽"
                }
            ],

            distributables: [
                {
                    name: "product",
                    label: "Товар"
                },
                {
                    name: "product_category",
                    label: "Категория товара"
                }
            ],

            selects: {
                ready: false,
                products: [],
                productCategories: []
            }
        };
    },

    methods: {
        removeDistribution(distribution) {
            this.distributions.splice(
                this.distributions.indexOf(distribution),
                1
            );
        },

        addDistribution() {
            this.distributions.push({
                id: +new Date(),
                distributable_type: "product_category"
            });
        },

        fetch() {
            axios.get(this.resource.endpoint).then(response => {
                this.distributions = response.data.data;
                this.resource.ready = true;
            });
        },

        submit() {
            axios
                .post(this.resource.endpoint, {
                    distributions: this.distributions
                })
                .then(response => {
                    this.$message.success("Данные сохранены");
                });
        },

        async fetchSelects() {
            await axios.get("/admin/products/all").then(response => {
                this.selects.products = response.data.data;
            });

            await axios.get("/admin/products/categories/all").then(response => {
                this.selects.productCategories = response.data.data;
            });

            this.selects.ready = true;
        }
    },

    mounted() {
        this.fetch();
        this.fetchSelects();
    }
};
</script>